import formatTitle from "./formatTitle";

export default formatTitle;
